import { createFileRoute } from "@tanstack/react-router";
import BipolarDisorderPage from "@/pages/BipolarDisorderPage";
import { buildConditionSchema } from "@/components/ConditionPageLayout";
export const Route = createFileRoute("/bipolar-disorder-coral-springs-fl")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Bipolar Disorder Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Bipolar disorder treatment in Coral Springs, FL. Medication management, therapy, and supportive care for bipolar disorder at Neuro Wellness TMS.",
        },
        {
          property: "og:title",
          content: "Bipolar Disorder Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Bipolar disorder treatment in Coral Springs, FL. Medication management, therapy, and supportive care for bipolar disorder at Neuro Wellness TMS.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/bipolar-disorder-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/bipolar-disorder-coral-springs-fl",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            buildConditionSchema({
              seoTitle:
                "Ketamine for Bipolar Disorder Treatment Coral Springs, FL | Neuro Wellness",
              seoDescription:
                "Breakthrough ketamine therapy for bipolar disorder in Coral Springs, FL. Fast relief for bipolar depression and mood stabilization at Neuro Wellness TMS Centers.",
              canonical: "/bipolar-disorder-coral-springs-fl",
              breadcrumbs: [
                { name: "Services", href: "/services-directory" },
                {
                  name: "Conditions Treated",
                  href: "/ketamine-treatment-coral-springs-fl",
                },
                {
                  name: "Bipolar Disorder",
                  href: "/bipolar-disorder-coral-springs-fl",
                },
              ],
            }),
          ),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BipolarDisorderPage />;
}
